
@if (drawerRendered) {
<bo-activity-preview-drawer
  [visible]="state.visible"
  [skipEnterAnimation]="state.skipEnterAnimation"
  [coveredByDialog]="coveredByDialog || deleteDialogVisible"
  [activityDraft]="state.draft"
  [activityLevel]="state.level"
  [sportOptions]="sportOptions"
  [levelOptions]="activityPreview.getLevelOptions(state.draft, sportTypeConfigs)"
  [selectedSportValue]="getSportOptionValue(state.draft?.sport ?? '')"
  [coverPhotoSrc]="getActivityCoverPhotoSrc()"
  [hasCoverPhoto]="hasActivityCoverPhoto()"
  [coverPhotoMenuVisible]="state.coverPhotoMenuVisible"
  [editingName]="state.editingName"
  [editingDescription]="state.editingDescription"
  [editingRouteUrl]="state.editingRouteUrl"
  [editingSport]="state.editingSport"
  [editingLevel]="state.editingLevel"
  [editActionMode]="isEditActionMode()"
  [canSave]="activityPreview.canSave(
    state.draft,
    state.original,
    state.level,
    state.originalLevel,
    defaultCoverPhotoUrl
  )"
  [operationErrorMessage]="state.visible ? externalOperationError : ''"
  [discardSuccessVisible]="state.discardSuccessVisible"
  [saveSuccessVisible]="state.saveSuccessVisible"
  [createdOn]="activityPreview.getCreatedOn(state.draft)"
  [scheduleLabel]="activityPreview.getScheduleLabel(state.draft)"
  [startDate]="activityPreview.getStartDate(state.draft)"
  [endDate]="activityPreview.getEndDate(state.draft)"
  [durationLabel]="activityPreview.getDurationLabel(state.draft)"
  [hostEmail]="activityPreview.getHostEmail(state.draft)"
  [participantTotal]="activityPreview.getParticipantTotal(state.draft)"
  [participants]="activityPreview.getVisibleParticipants(state.draft, state.participantsExpanded, 3)"
  [participantsExpanded]="state.participantsExpanded"
  [participantsMoreCount]="activityPreview.getParticipantsMoreCount(state.draft, 3)"
  [canToggleParticipants]="activityPreview.canToggleParticipants(state.draft, state.participantsExpanded, 3)"
  [participantsLoading]="participantsLoading"
  [getSportIconPath]="getSportIconPath"
  [backButtonIcon]="backButtonIcon"
  [backButtonLabel]="backButtonLabel"
  [dismissible]="dismissibleOnMaskClick"
  (shown)="onShown()"
  (hidden)="onHidden()"
  (back)="onBackClick()"
  (closed)="onFooterClose()"
  (bodyScrolled)="onBodyScroll($event)"
  (draftChanged)="onDraftChanged()"
  (operationErrorDismissed)="dismissOperationError()"
  (discardSuccessDismissed)="dismissDiscardSuccess()"
  (saveSuccessDismissed)="dismissSaveSuccess()"
  (photoMenuToggled)="toggleCoverPhotoMenu($event)"
  (photoMenuClosed)="closeCoverPhotoMenu()"
  (coverPhotoSelected)="onCoverPhotoSelected($event)"
  (coverPhotoError)="onCoverPhotoError()"
  (coverPhotoRemoved)="removeCoverPhoto()"
  (editNameRequested)="editName()"
  (editDescriptionRequested)="editDescription()"
  (editRouteUrlRequested)="editRouteUrl()"
  (editSportRequested)="editSport()"
  (editLevelRequested)="editLevel()"
  (undoNameRequested)="undoName()"
  (undoDescriptionRequested)="undoDescription()"
  (undoRouteUrlRequested)="undoRouteUrl()"
  (undoSportRequested)="undoSport()"
  (undoLevelRequested)="undoLevel()"
  (sportChanged)="onSportChange($event)"
  (levelChanged)="onLevelChange($event)"
  (toggleParticipants)="toggleParticipantsExpanded()"
  (deleteRequested)="handleDeleteOrCancel()"
  (discardRequested)="discardChanges()"
  (saveRequested)="saveChanges()"
/>
}

@if (manageDeleteDialog) {
<bo-delete-confirm-dialog
  [visible]="deleteDialogVisible"
  [closing]="deleteDialogClosing"
  [confirmed]="deleteConfirmed"
  targetLabel="activity"
  [targetName]="state.draft?.name ?? ''"
  [errorMessage]="externalOperationError"
  (confirmedChange)="deleteConfirmed = $event"
  (closed)="closeDeleteDialog()"
  (hidden)="onDeleteDialogHidden()"
  (deleted)="confirmStandaloneDelete()"
/>
}

<bo-cancel-activity-dialog
  [visible]="cancelDialogVisible"
  [closing]="cancelDialogClosing"
  [restoreWithoutTransition]="skipCancelDialogEnterAnimation"
  [confirmed]="cancelConfirmed"
  [activityName]="state.draft?.name ?? ''"
  (closed)="closeCancelDialog()"
  (hidden)="onCancelDialogHidden()"
  (confirmedChange)="onCancelConfirmedChange($event)"
  (canceled)="onCancelConfirmed()"
/>

<bo-cancel-paid-activity-dialog
  [visible]="cancelPaidDialogVisible"
  [closing]="cancelPaidDialogClosing"
  [restoreWithoutTransition]="skipCancelPaidDialogEnterAnimation"
  [confirmed]="cancelPaidConfirmed"
  [activityName]="state.draft?.name ?? ''"
  (closed)="closeCancelPaidDialog()"
  (hidden)="onCancelPaidDialogHidden()"
  (confirmedChange)="onCancelPaidConfirmedChange($event)"
  (canceled)="onCancelPaidConfirmed()"
/>
